import HistoryPage from './HistoryPage'

export default HistoryPage
